import { gql, QueryHookOptions, useQuery } from '@apollo/client';
import { User } from '../../dto';
import { languageStringMinFrag } from './fragments';

type Variables = { userId: number };
type Results = {
  user: {
    roadmapMilestoneGroups: User['roadmapMilestoneGroups'];
  }
};

export const useRoadmapMilestoneGroups = (options?: QueryHookOptions<Results, Variables>) => {
  const query = gql`
  ${languageStringMinFrag}
    query getRoadmapMilestoneGroups($userId: Int!) {
      user(id: $userId) {
        roadmapMilestoneGroups {
          id
          sortIndex
          color
          defaultMilestoneId
          name {
            ...LangStringMinFrag
          }
          description {
            ...LangStringMinFrag
          }
        }
      }
    }
  `;

  return useQuery(query, options);
};

export default useRoadmapMilestoneGroups;
